import { render, staticRenderFns } from "./BusContentMangeIndex.vue?vue&type=template&id=73064592&scoped=true"
import script from "./BusContentMangeIndex.vue?vue&type=script&lang=js"
export * from "./BusContentMangeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73064592",
  null
  
)

export default component.exports